import { createI18n, useI18n } from 'vue-i18n'
import { languages } from '@/locales/index.js'
const env = import.meta.env;

const messages = Object.assign(languages)

// force LocalStorage as locale by default as navigator language detection creates issues with SSR and static hosting
if(!localStorage.getItem('locale')){
  var current = navigator.language || navigator.userLanguage;
  const shortLang = current.split('-')[0]
  const availableLangs = Object.keys(messages)
  const finalLang = availableLangs.includes(shortLang) ? shortLang : env.VITE_APP_LANGUAGE
  localStorage.setItem('locale', finalLang )
}
const firstLocale = localStorage.getItem('locale')

const i18n = new createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: firstLocale,
  fallbackLocale: env.VITE_APP_LANGUAGE,
  messages,
})

const locales = { i18n, useI18n }
export default locales